/** @jsx jsx */
import { jsx } from '@emotion/react';

import {
  AIGenerateIcon,
  ArtIcon,
  BriefcaseIcon,
  CodeIcon,
  GlobeIcon,
  HealthIcon,
  LaptopIcon,
  LaunchIcon,
  MathIcon,
  MembersIcon,
  ScienceIcon,
  TrendingIcon,
} from '@coursera/cds-icons';

type Props = {
  slug: string;
};

const PillIcon = (props: Props) => {
  const { slug } = props;
  switch (slug) {
    case 'artificial-intelligence':
      return <AIGenerateIcon />;
    case 'arts-and-humanities':
      return <ArtIcon />;
    case 'business':
      return <BriefcaseIcon />;
    case 'computer-science':
      return <CodeIcon />;
    case 'data-science':
      return <TrendingIcon />;
    case 'information-technology':
      return <LaptopIcon />;
    case 'health':
      return <HealthIcon />;
    case 'math-and-logic':
      return <MathIcon />;
    case 'personal-development':
      return <LaunchIcon />;
    case 'physical-science-and-engineering':
      return <ScienceIcon />;
    case 'social-sciences':
      return <MembersIcon />;
    case 'language-learning':
      return <GlobeIcon />;
    default:
      return null;
  }
};

export default PillIcon;
